import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import opendropdown from "../../../assets/images/opendropdown.svg";
import closedropdown from "../../../assets/images/closedropdown.svg";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener"; // Generated by Copilot

// Preference type
interface PreferencesDropdownProps {
  preferences: Array<{ name: string; value: string | number }>;
  highlightPreference?: string | number;
  onSelect: (pref: any) => void;
  onFlip?: () => void;
  user?: any;
  swapRequests?: any[];
  isswapRequest?: boolean;
  mahatriachoiceType?: string; // Added to handle mahatriaChoiceType
}

const UserPreferencesDropdown: React.FC<PreferencesDropdownProps> = ({
  preferences,
  highlightPreference,
  onSelect,
  onFlip,
  user,
  swapRequests,
  mahatriachoiceType,
  isswapRequest = false,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const anchorRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [openUpward, setOpenUpward] = useState(false);

  const handlePrefSelect = (e: React.MouseEvent, pref: any) => {
    e.stopPropagation();
    onSelect(pref);
    setIsOpen(false);
    // Trigger flip animation
    // if (onFlip) {
    //   onFlip();
    // }
  };
  useEffect(() => {
    if (!isOpen) return;
    const checkDropdownDirection = () => {
      if (!anchorRef.current || !dropdownRef.current) return;
      const triggerRect = anchorRef.current.getBoundingClientRect();
      const dropdownHeight = dropdownRef.current.offsetHeight;
      const spaceBelow = window.innerHeight - triggerRect.bottom;
      const spaceAbove = triggerRect.top;
      if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
        setOpenUpward(true);
      } else {
        setOpenUpward(false);
      }
    };
    checkDropdownDirection();
    window.addEventListener("resize", checkDropdownDirection);
    window.addEventListener("scroll", checkDropdownDirection, true); // <-- add this line
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        anchorRef.current &&
        !anchorRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("resize", checkDropdownDirection);
      window.removeEventListener("scroll", checkDropdownDirection, true); // <-- add this line
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  console.log("highlightPreference", highlightPreference);
  console.log("getPreferences", preferences);
  return (
    <div
      className={styles.preferenceDropdownWrapper}
      ref={dropdownRef}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={styles.preferenceDropdownTrigger}
        ref={anchorRef}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen((prev) => !prev);
        }}
      >
        {preferences.length > 0 &&
          highlightPreference !== "preferencesUnallocated" && (
            <span
              className={
                highlightPreference === "mahatriaChoiceUnallocated"
                  ? `${styles.staticLabel} ${styles.staticLabelMahatria}`
                  : styles.staticLabel
              }
            >
              {highlightPreference === "mahatriaChoiceUnallocated"
                ? "Any HDB/MSD"
                : "select to move"}
            </span>
          )
        }
        <span className={styles.dropdownArrowIcon}>
          <img src={isOpen ? opendropdown : closedropdown} alt="dropdown" />
        </span>
      </div>
      {isOpen &&
        (isswapRequest === false ? (
          <div
            ref={dropdownRef}
            className={`${styles.dropdownMenu} ${openUpward ? styles.dropdownMenuUp : styles.dropdownMenuDown}`}
          >
            {!highlightPreference ||
              highlightPreference === "preferencesUnallocated" ? (
              <>
                <div
                  className={styles.dropdownItem}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect({
                      name: "YTD",
                      value: "yet-to-decide",
                    });
                    setIsOpen(false);
                  }}
                >
                  YTD
                </div>
                <div
                  className={styles.dropdownItem}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect({ name: "Hold", value: "hold" });
                    setIsOpen(false);
                  }}
                >
                  Hold
                </div>
              </>
            ) : (
              <div>
                <div className={styles.preferenceNameLabel}>
                  {highlightPreference !== "mahatriaChoiceUnallocated" &&
                    mahatriachoiceType !== "mahatriaChoiceBlessed"
                    ? "Preferences"
                    : ""}
                </div>
                {preferences.map((pref, idx) => {
                  const isHighlighted =
                    highlightPreference === pref.name ||
                    (highlightPreference === "yet-to-decide" &&
                      pref.value === "yet-to-decide") ||
                    (highlightPreference === "hold" && pref.value === "hold");
                  return (
                    <div
                      key={pref.value}
                      className={`${styles.dropdownItem} ${isHighlighted ? styles.highlight : ""} ${isHighlighted ? styles.disabled : ""}`}
                      onClick={
                        isHighlighted
                          ? undefined
                          : (e) => {
                            e.stopPropagation();
                            handlePrefSelect(e, pref);
                          }
                      }
                      style={isHighlighted ? { pointerEvents: "none" } : {}}
                    >
                      {`${pref.name} ${mahatriachoiceType !== "mahatriaChoiceBlessed" && highlightPreference !== "mahatriaChoiceUnallocated" && mahatriachoiceType !== "mahatriaChoiceHold" ? "- choice " + (idx + 1) : ""}`}
                    </div>
                  );
                })}
                {mahatriachoiceType !== "mahatriaChoiceBlessed" &&
                  highlightPreference !== "mahatriaChoiceUnallocated" && mahatriachoiceType !== "mahatriaChoiceHold" && (
                    <>
                      <div className={styles.dropdownDivider} />
                      <div
                        className={`${styles.dropdownItem} ${highlightPreference === "yet-to-decide" ? styles.highlight : ""} ${highlightPreference === "yet-to-decide" ? styles.disabled : ""}`}
                        onClick={
                          highlightPreference === "yet-to-decide"
                            ? undefined
                            : (e) => {
                              e.stopPropagation();
                              onSelect({
                                name: "YTD",
                                value: "yet-to-decide",
                              });
                              setIsOpen(false);
                            }
                        }
                        style={
                          highlightPreference === "yet-to-decide"
                            ? { pointerEvents: "none" }
                            : {}
                        }
                      >
                        YTD
                      </div>
                      <div
                        className={`${styles.dropdownItem} ${highlightPreference === "hold" ? styles.highlight : ""} ${highlightPreference === "hold" ? styles.disabled : ""}`}
                        onClick={
                          highlightPreference === "hold"
                            ? undefined
                            : (e) => {
                              e.stopPropagation();
                              onSelect({ name: "Hold", value: "hold" });
                              setIsOpen(false);
                            }
                        }
                        style={
                          highlightPreference === "hold"
                            ? { pointerEvents: "none" }
                            : {}
                        }
                      >
                        Hold
                      </div>
                    </>
                  )}
              </div>
            )}
          </div>
        ) : (
          <div
            ref={dropdownRef}
            className={`${styles.dropdownMenu} ${openUpward ? styles.dropdownMenuUp : styles.dropdownMenuDown}`}
          >
            <div className={styles.preferenceNameLabel}>Swap Preferences</div>
            {swapRequests &&
              swapRequests.length > 0 &&
              swapRequests.map((req, idx) => (
                <div
                  key={idx}
                  className={styles.dropdownItem}
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePrefSelect(e, req);
                  }}
                >
                  {req.name}
                </div>
              ))}
            {/* Generated by Copilot */}
            {swapRequests && swapRequests.length > 0 && (
              <div className={styles.dropdownDivider} />
            )}
            {preferences
              .filter(
                (pref) => !swapRequests?.some((req) => req.name === pref.name),
              )
              .map((pref, idx) => {
                // Support both string/number and object for highlightPreference
                console.log("highlightPreference", highlightPreference, pref.value);

                const isHighlighted = highlightPreference === pref.name;
                return (
                  <div
                    key={pref.value}
                    className={`${styles.dropdownItem} ${isHighlighted ? styles.highlight : ""} ${isHighlighted ? styles.disabled : ""}`}
                    onClick={
                      isHighlighted
                        ? undefined
                        : (e) => {
                          e.stopPropagation();
                          handlePrefSelect(e, pref);
                        }
                    }
                    style={isHighlighted ? { pointerEvents: "none" } : {}}
                  >
                    {`${pref.name}`}
                  </div>
                );
              })}
          </div>
        ))}
    </div>
  );
};

export default UserPreferencesDropdown;
